import { render, staticRenderFns } from "./SemiOrExportDiscrepancy.vue?vue&type=template&id=280cda36&"
import script from "./SemiOrExportDiscrepancy.vue?vue&type=script&lang=js&"
export * from "./SemiOrExportDiscrepancy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports